import classNames from 'classnames';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useDebounceFn, useInterval } from 'ahooks';
import { message } from '@/components/AntD';
import FilePiker from '@/components/FileUpload/FilePiker';
import OBSUploader from '@/components/FileUpload/OBSUpload';

import './index.scss';

export default forwardRef(function DragUpload(props, ref) {

  const {
    successTips, className, clickUpload, children, onChange, maxFiles = 1, checkTextLength, errMsg,
    onProgress, type, size, checkImage, acceptTypes = [], options = {}, isSuccessMessage = true,
    maxWordW, onBeforeUpload
  } = props;
  const [isDraggedIn, setIsDraggedIn] = useState(false);
  const [uploadList, setUploadList] = useState([]);
  const dragRef = useRef(null);
  const fileNode = useRef(null);
  const dragleaveTimerRef = useRef();

  const fakeTimer = useInterval(() => {
    let fakeIdx = uploadList.findIndex(r => r.fake);
    if(fakeIdx === -1) return;
    if(uploadList[fakeIdx].percent > 90) {
      return;
    }
    onUploadListChange({ ...uploadList[fakeIdx], percent: uploadList[fakeIdx].percent + 1 }, fakeIdx);
  }, uploadList.find(r => r.fake) ? 2000 : undefined);

  useEffect(() => {
    if(dragRef.current) {
      dragRef.current.addEventListener('dragenter', dragEnter, false);
      dragRef.current.addEventListener('dragover', dragOver, false);
      dragRef.current.addEventListener('drop', drop, false);
      dragRef.current.addEventListener('dragleave', dragleave, false);
      document.addEventListener('drop', function(e) {
        hiddenDraggedIn();
        e.preventDefault();
      }, false);
      document.addEventListener('dragover', function(e) {
        e.preventDefault();
      }, false);
    }
    return fakeTimer;
  }, []);

  useEffect(() => {
    onProgress && onProgress(uploadList);
  }, [uploadList]);

  useImperativeHandle(ref, () => ({
    deleteFile,
    forceDeteleFile,
    reUploadFile,
    uploadFile,
    clearFile,
    resetFiles,
    onUploadListChange
  }));

  function clearFile() {
    setUploadList([]);
  }

  function resetFiles(files) {
    setUploadList(files);
  }

  function reUploadFile(index) {
    const file = uploadList[index].file;
    setUploadList(prev => {
      const arr = prev.slice();
      arr[index] = Object.assign(arr[index], { percent: arr[index]?.percent || 0, success: false, done: false });
      return arr;
    });
    const uploader =  new OBSUploader({
      file: file,
      config: {
        fail: (error) => {
          onUploadListChange({ percent: 100, success: false, done: true }, index);
        },
        process: (data) => {
          onUploadListChange({ percent: data.percent, success: false, done: false }, index);
        },
        success: (data) => {
          onUploadListChange({ percent: 100, data, success: true, done: true }, index);
        }
      }
    });
    // console.log('上传啊');
    // 上传
    uploader.upload();
  }
  function deleteFile(index) {
    setUploadList(prev => {
      const arr = prev.slice();
      arr[index] = Object.assign(arr[index], { isDelete: true });
      return arr;
    });
  }

  /** 强制删除文件 */
  function forceDeteleFile(index) {
    setUploadList(prev => {
      const arr = prev.slice();
      arr.splice(index, 1);
      return arr;
    });
  }

  function dragleave(e) {
    hiddenDraggedIn();
    e.stopPropagation();
    e.preventDefault();
  }

  function dragEnter(e) {
    e.stopPropagation();
    e.preventDefault();
  }

  function dragOver(e) {
    clearTimeout(dragleaveTimerRef.current);
    setIsDraggedIn(true);
    e.stopPropagation();
    e.preventDefault();
  }

  function drop(e) {
    const files = e.dataTransfer.files;
    fileNode.current && fileNode.current.selectFile({
      target: {
        files: files
      }
    });
    // triggerChange([...files]);
  }

  const uploadFile = () => {
    fileNode.current && fileNode.current.addFile();
  };

  const { run: triggerChange } = useDebounceFn((files) => {
    if(files?.length) {
      // 已经上传的个数
      const len = uploadList.filter(e => !e.isDelete).length;
      if(files?.length > maxFiles - len) {
        message.error(errMsg || `最多只能上传${maxFiles}个文件`);
        return false;
      }

      if(acceptTypes.length) {
        const validated = [...files].every(item => {
          const arr = item.name.split('.');
          const suffix = arr.pop();
          return acceptTypes.includes(suffix.toLowerCase());
        });
        if(!validated) {
          message.error(`请上传“${acceptTypes.join(',')}”格式文件`);
          return false;
        }
      }
      const list = [].concat([...files].map(e => ({ file: e })), uploadList);
      if(checkTextLength) {
        setUploadList(list.map(v => Object.assign({ percent: 0, success: false, done: false }, v)));
      } else {
        uoloadFiles(files);
        setUploadList([]);
      }
      onChange && onChange(files);
    }
    return false;
  }, { wait: 50 });

  function onBefore(files) {
    if(props.onBefore) {
      return props.onBefore(files);
    }
    onBeforeUpload && onBeforeUpload(files);
    setIsDraggedIn(false);
    triggerChange(files);
    return false;
  }
  function onClickUpload(e) {
    if(!maxFiles) {
      return;
    }
    e.stopPropagation();
    e.preventDefault();
    if(clickUpload) {
      clickUpload();
    } else {
      uploadFile();
    }
  }

  function hiddenDraggedIn() {
    clearTimeout(dragleaveTimerRef.current);
    dragleaveTimerRef.current = setTimeout(() => {
      setIsDraggedIn(false);
    }, 100);
  }

  function uoloadFiles(files) {
    const list = [].concat(uploadList, [...files].map(e => ({ file: e })));
    setUploadList(list);
    list.forEach((item, index) => {
      if(!item.done) {
        const uploader =  new OBSUploader({
          file: item.file,
          config: {
            fail: (error) => {
              onUploadListChange({ percent: 100, success: false, done: true }, index);
              message.warning('上传失败');
            },
            process: (data) => {
              onUploadListChange({ percent: data.percent, success: false, done: false }, index);
            },
            success: (data) => {
              const { url = '', fileUrl } = data;
              console.log(url, fileUrl);
            }
          }
        });
        // 上传
        uploader.upload();
      }
    });
  }

  function onUploadListChange(obj, index) {
    setUploadList(prev => {
      const arr = prev.slice();
      if(obj.percent === 100 && obj.fake) obj.fake = false;
      arr[index] = Object.assign(arr[index], obj);
      return arr;
    });
  }

  return (
    <div
      ref={dragRef}
      className={classNames('DragUpload_NXkVJV', { 'active': isDraggedIn }, className)}
    >
      <div className="isDraggedIn-content">
        <div className="icon" />
        <span>释放鼠标上传</span>
      </div>
      <div onClick={onClickUpload} className="inner-content">{children}</div>
      <FilePiker
        sizeLimit={size || 1024 * 1024}
        checkImage={checkImage}
        className="dragger-filePiker"
        fileRef={fileNode}
        type={type || 'WORDANDPDF'}
        pikerText=" "
        onBefore={onBefore}
        options={{ maxFiles, multiple: maxFiles > 1, ...options }}
        maxWordW={maxWordW}
      />

    </div>
  );
});
